import { listingUtils_getResourceIdAndSlug } from 'app/shared/utils/listingUtils';
import routeUtils from 'app/shared/utils/routeUtils';

type MountFetchStrategyInput = {
  pathname: string;
  query: Record<string, string | boolean | undefined>;
  areaResourceId: string;
  searchSlug: string;
  isClientSideLoadedPage: boolean;
  isInitialSsrPage: boolean;
};

export type MountFetchStrategy =
  | { type: 'listingsOnly'; pathname: string; query: Record<string, string | boolean | undefined> }
  | { type: 'fullFetch'; pathname: string; query: Record<string, string | boolean | undefined> }
  | { type: 'none' };

export function getMountFetchStrategy({
  pathname,
  query,
  areaResourceId,
  searchSlug,
  isClientSideLoadedPage,
  isInitialSsrPage,
}: MountFetchStrategyInput): MountFetchStrategy {
  const { resourceId: pathResourceId, slug: pathSlug } = listingUtils_getResourceIdAndSlug(pathname);
  const isNearMeUrl = routeUtils.isNearMeUrl(pathSlug);
  const hasResourceIdChangedFromLastMount = !isNearMeUrl && pathResourceId !== areaResourceId;
  const hasSlugChangedFromLastMount = !isNearMeUrl && pathSlug !== searchSlug;
  const hasUserMovedBackToNearMePage =
    isNearMeUrl && isInitialSsrPage === false && !hasResourceIdChangedFromLastMount && !hasSlugChangedFromLastMount;

  const shouldFetchClientSideListings =
    (isClientSideLoadedPage && !isInitialSsrPage) || hasResourceIdChangedFromLastMount || hasUserMovedBackToNearMePage;

  if (!shouldFetchClientSideListings) {
    return { type: 'none' };
  }

  const isReturningWithSameSlugAndArea = !hasResourceIdChangedFromLastMount && !hasSlugChangedFromLastMount;
  const hasNonPaginationQueryParams = Object.keys(query).some((k) => k !== 'page');

  if (isReturningWithSameSlugAndArea && !hasNonPaginationQueryParams) {
    return { type: 'listingsOnly', pathname, query };
  }

  return { type: 'fullFetch', pathname, query };
}
